/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useRef, useEffect } from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

import CardWithButtons from './Common/CardWithButtons';
import CardWithInput from './Common/CardWithInput';
import { Button, CircularProgress, FormControlLabel, Switch, Typography } from '@material-ui/core';
import mbpUtil from 'mbp-api-util';
import Reaptcha from 'reaptcha';
import { bool, func, object, string } from 'prop-types';
import { getAccessTokenSafely } from '../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

import { connect, useSelector } from 'react-redux';
import { getBrand, getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getProfileInfo } from '../../../state/Selectors';
import Disclaimer from './Common/Disclaimer';
import DadJokeLandingPageTopBg from './assets/dadjokegpt/DadJokeLandingPageTopBg';
import DadJokeLandingPageBottomBg from './assets/dadjokegpt/DadJokeLandingPageBottomBg';
import CardWithButtonsMultiple from './Common/CardWithButtonsMultiple';
import composePersonalizedContent from '../../../../../../apis/chatgpt-apis/composePersonalizedContent';
import { useMutation } from 'react-query';

const useStyles = (mobile, isDadJokeGPT) =>
    makeStyles((theme) => ({
        contentContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',
            zIndex: '2',
            height: '100%',
            width: '100%',
            maxWidth: '715px',
            color: `${theme.palette.common.black} !important`,
            '& > form': {
                width: '100%',
                textAlign: 'center',
            },
            padding: isDadJokeGPT ? (mobile ? '139px 0 9px 0' : '139px 0 19px 0') : '32px 0 12px 0',
        },
        playContainer: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: '100%',
        },
        title: {
            textTransform: 'unset !important',
            fontSize: `${mobile ? '40px' : '72px'} !important`,
            lineHeight: `${isDadJokeGPT ? `${mobile ? '60px' : '94px'}` : '0'} !important`,
            fontWeight: '800 !important',
            fontFamily: 'Dosis !important',
            textAlign: 'center',
            margin: '0 0 0 0 !important',
            marginBottom: `${isDadJokeGPT ? `${mobile ? '16px' : '34px'}` : '16px'} !important`,
            '& img': {
                maxWidth: '100%',
                width: !isDadJokeGPT && !mobile ? '450px' : undefined,
            },
        },
        subtitle: {
            color: `${isDadJokeGPT ? '#FFFFFF' : ''}`,
            fontWeight: 400,
            maxWidth: `${isDadJokeGPT && !mobile ? '' : '40ch'}`,
            fontSize: `${mobile ? '16px' : '20px'} !important`,
            lineHeight: `${mobile ? '24px' : '32px'}`,
            textAlign: 'center !important',
            marginBottom: '0px !important',
        },
        generateButton: {
            width: '100% !important',
            height: '58px',
            border: 'none !important',
            float: `${isDadJokeGPT ? 'right' : 'none'} !important`,
            borderRadius: `${isDadJokeGPT ? '3px' : '8px'} !important`,
            margin: `${isDadJokeGPT ? '24px' : '0'} 0 12px 0 !important`,
            lineHeight: '26px',
            textTransform: 'none !important',
            backgroundColor: `${isDadJokeGPT ? '#081E3F' : '#F55858'} !important`,

            color: `${theme.palette.common.white}`,
            fontWeight: '700 !important',
            '&:disabled': {
                color: '#9D9D9D !important',
                border: '0 !important',
                backgroundColor: '#D9D9D9 !important',
            },
            '& > span': {
                fontSize: `${mobile ? '16px' : '18px'} !important`,
            },
        },
        error: {
            textAlign: 'center !important',
            fontWeight: '400',
            fontSize: '14px !important',
            lineHeight: '20px',
            color: '#DF3030',
            margin: '0 !important',
        },
        recaptchaContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: isDadJokeGPT ? 'none' : '24px',
        },
        root: {
            width: 57,
            height: 28,
            padding: 0,
            marginRight: 10,
        },
        switchBase: {
            padding: 0,
            margin: 4,
            transitionDuration: '300ms',
            '&$checked': {
                transform: 'translateX(29px)',
                color: `${theme.palette.common.white}`,
                backgroundColor: `${isDadJokeGPT ? '#081E3F' : '#000000'}`,
                '& + $track': {
                    backgroundColor: `${theme.palette.common.black}`,
                    opacity: 1,
                    border: 0,
                },
            },
            '&$focusVisible $thumb': {
                color: `${theme.palette.common.black}`,
                border: 0,
            },
        },
        thumb: {
            boxSizing: 'border-box',
            width: 20,
            height: 20,
        },
        track: (props) => ({
            borderRadius: 28 / 2,
            border: 0,
            backgroundColor: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}!important`,
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            '&:before, &:after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                fontSize: '12px',
                lineHeight: '18px',
                fontWeight: 600,
                transform: 'translateY(-50%)',
                width: 24,
                height: 20,
                transition: theme.transitions.create(['opacity'], {
                    duration: 500,
                }),
            },
            '&:before': {
                content: '"OFF"',
                color: '#FFF',
                opacity: props.switchOn ? '0' : '1',
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="#FFFFFF" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
                right: '6px',
            },
            '&:after': {
                content: '"ON"',
                color: '#FFF',
                opacity: props.switchOn ? '1' : '0',
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="#FFFFFF" d="M19,13H5V11H19V13Z" /></svg>')`,
                left: '6px',
            },
        }),
        checked: {},
        focusVisible: {},
        formControlLabel: {
            margin: '0 10px 0px 10px !important',
        },
        switchLabel: {
            fontSize: '16px !important',
            fontFamily: 'Lato, sans-serif',
            lineHeight: '24px',
            color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}`,
            fontWeight: 400,
            padding: 0,
            margin: '0 !important',
            textAlign: 'left',
        },
        landingPageTop: {
            width: '100vw',
            height: '100%',
            zIndex: 1,
            overflow: 'hidden',
            position: 'absolute',
            maxWidth: '100vw',
            '& img': {
                top: `${mobile ? '-600px' : '-515px'}`,
                width: '100%',
                maxWidth: '1976px',
                height: '1235px',
                position: 'absolute',
            },
        },
        landingPageBottom: {
            width: '100vw',
            height: '100%',
            zIndex: 1,
            overflow: 'hidden',
            position: 'absolute',
            maxWidth: '100vw',
            '& img': {
                width: '100%',
                bottom: `${mobile ? '-489px' : '-750px'}`,
                height: '1040px',
                position: 'absolute',
                [theme.breakpoints.down(500)]: {
                    bottom: '-489px',
                },
            },
        },
    }));

const PoemLandingPage = ({
    mobile,
    isDadJokeGPT,
    trackEvent,
    occasion,
    handlePoemMutationSuccess,
    handlePoemMutationError,
    options,
    selections,
    setSelections,
    error,
    setError,
    ...props
}) => {
    const people = ['Mom', 'Grandma', 'Wife'];
    const likes = [
        'Gardening',
        'Wine & Bar',
        'Travel',
        'Tailgating',
        'Spa Treatments',
        'Crafts / DIY',
        'Exercise',
        'Reading',
        'Music',
        'Cooking',
        'Photography',
    ];

    const dadJokeCreativeOptions = ['Dad Joke', 'Poem', 'Haiku', 'Rhyme', 'Limerick', 'Song'];

    const dadJokePeople = ['Dad', 'Grandpa', 'Husband', 'Uncle', 'Brother'];

    const placeholders = isDadJokeGPT ? ['Grilling', 'Sky Diving', 'Disco'] : ['Pasta', 'Sky diving', 'Disco'];
    const dadJokePlaceholders = ['Fishing'];

    const dadJokeOptions = {
        writeA: '',
        forMy: '',
        whoLikes: { optionA: '' },
    };

    const APP_GOOGLE_RECAPCHA_KEY = mbpUtil.getEnv('APP_GOOGLE_RECAPCHA_KEY');

    const createPoemMutation = useMutation({
        mutationFn: composePersonalizedContent,
        onSuccess: ({ data: { poem, isSuccessful } }) => handlePoemMutationSuccess(poem, isSuccessful),
        onError: handlePoemMutationError,
    });

    const [captchaVerified, setCaptchaVerified] = useState('');
    const [switchOn, setSwitchOn] = useState(false);
    const [isDadJokeSelected, setIsDadJokeSelected] = useState(false);

    const googleCaptcha = useRef(null);

    const featureFlags = useSelector(getFeatureFlags);
    const brand = useSelector(getBrand);
    const profileInfo = useSelector(getProfileInfo);
    const isPoemEnforcingCharLimit = featureFlags?.['is-poem-page-enforced-character-limit-enabled'];

    const googleCaptchaDisabled = featureFlags['is-poem-page-recaptcha-disabled'];

    const MomVerseDesktop =
        'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcdaf24cfa8192ed8/66104d69ca5a97909a554be3/MomVerse-MobileV2.svg';
    const MomVerseMobile =
        'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcdaf24cfa8192ed8/66104d69ca5a97909a554be3/MomVerse-MobileV2.svg';
    const DadJokeDesktop =
        'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltef40a00fbf9f2b6e/646bb03f1fffbf59b69b5e0d/desktop-dadjokegpt.svg';
    const DadJokeMobile =
        'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcc3cc7051739c82c/646bb033df57fd67196568c9/mobile-dadjokegpt.svg';

    const resetCaptcha = async () => {
        await googleCaptcha.current?.reset();
        setCaptchaVerified(false);
    };

    const classesLayout = useStyles(mobile, isDadJokeGPT);
    const classes = classesLayout({ switchOn });

    const handleSetCreativeOption = (value) => {
        setSelections((prev) => ({
            ...prev,
            writeA: value.trim(),
        }));
    };

    const handleSetPeopleOption = (value) => {
        props.setRecipient(value);
        setSelections((prev) => ({
            ...prev,
            forMy: value.trim(),
        }));
    };

    const handleSetLikes = (name, value) => {
        setSelections((prev) => ({
            ...prev,
            whoLikes: {
                ...selections.whoLikes,
                [name]: value.trim(),
            },
        }));
    };

    const handleSetLikesMomVerse = (likes) => {
        setSelections((prev) => ({
            ...prev,
            // Who likes should probably be turned into an Array
            whoLikes: {
                optionA: likes?.[0]?.trim() || '',
                optionB: likes?.[1]?.trim() || '',
                optionC: likes?.[2]?.trim() || '',
            },
        }));
    };

    const checkGenerateEnabled = () => {
        const {
            writeA,
            forMy,
            whoLikes: { optionA },
        } = selections;
        const checkCaptchaVerified = googleCaptchaDisabled || captchaVerified;
        if (isDadJokeGPT && isDadJokeSelected)
            return writeA && forMy && optionA && checkCaptchaVerified && !createPoemMutation.isLoading;
        return forMy && optionA && checkCaptchaVerified && !createPoemMutation.isLoading;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const { forMy, whoLikes, writeA } = selections;
        const token = await getAccessTokenSafely();
        const captcha = (await googleCaptcha.current?.getResponse()) || '';
        const interests = Object.values(whoLikes).filter((interest) => !!interest);
        const occasion = isDadJokeGPT ? "Father's Day" : "Mother's Day";
        createPoemMutation.mutate({
            token,
            brand: brand?.description || '1-800-Flowers',
            interests,
            enforceCharacterLimit: isDadJokeGPT ? switchOn : false,
            recipient: forMy,
            userId: profileInfo?.email || '',
            verseType: isDadJokeGPT ? writeA : 'Poem',
            captchaToken: captcha,
            occasion,
        });
        !googleCaptchaDisabled && resetCaptcha();
    };

    useEffect(() => {
        setError('');
    }, [selections, captchaVerified, switchOn]);

    useEffect(() => {
        if (typeof window !== 'undefined') window.scrollTo(0, 0);
    }, []);

    if (isDadJokeGPT) {
        return (
            <>
                <div className={classes.landingPageTop}>
                    <DadJokeLandingPageTopBg mobile={mobile} />
                </div>
                <div className={classes.contentContainer}>
                    {/* h1 needs to change */}
                    <h1 className={classes.title}>
                        <img
                            width="100%"
                            alt="1800flowers.com DadJokeGPT"
                            src={mobile ? DadJokeMobile : DadJokeDesktop}
                        />
                    </h1>
                    {/* FOR SEO */}
                    <h1 style={{ display: 'none' }}>AI Dad Joke Generator</h1>
                    <p className={classes.subtitle}>
                        A FREE AI-powered composer that creates something for any dad in your life, from a bad dad joke
                        to a personalized poem.
                    </p>
                    <form onSubmit={(e) => handleFormSubmit(e)}>
                        <CardWithButtons
                            mobile={mobile}
                            handleOptionChange={handleSetCreativeOption}
                            title="Write a:"
                            options={dadJokeCreativeOptions}
                            placeholder="Or something else like… Rock Anthem"
                            setIsDadJokeSelected={setIsDadJokeSelected}
                            isDadJokeGPT={isDadJokeGPT}
                        />
                        <CardWithButtons
                            mobile={mobile}
                            handleOptionChange={handleSetPeopleOption}
                            title="For Your:"
                            options={dadJokePeople}
                            placeholder="Or someone else like.. Papa"
                            setIsDadJokeSelected={setIsDadJokeSelected}
                            isDadJokeGPT={isDadJokeGPT}
                        />
                        <CardWithInput
                            mobile={mobile}
                            handleOptionChange={handleSetLikes}
                            title="Who Likes:"
                            options={isDadJokeSelected ? dadJokeOptions : options}
                            selections={selections}
                            placeholders={isDadJokeSelected ? dadJokePlaceholders : placeholders}
                            isDadJokeGPT={isDadJokeGPT}
                        />
                        {isPoemEnforcingCharLimit && (
                            <FormControlLabel
                                className={classes.formControlLabel}
                                control={
                                    <Switch
                                        focusVisibleClassName={classes.focusVisible}
                                        disableRipple
                                        onClick={() => setSwitchOn(!switchOn)}
                                        classes={{
                                            root: classes.root,
                                            switchBase: classes.switchBase,
                                            thumb: classes.thumb,
                                            track: classes.track,
                                            checked: classes.checked,
                                        }}
                                    />
                                }
                                label={
                                    <Typography className={classes.switchLabel}>
                                        Limit to 80 characters for your gift message
                                    </Typography>
                                }
                            />
                        )}
                        {!googleCaptchaDisabled && (
                            <div className={classes.recaptchaContainer}>
                                <Reaptcha
                                    ref={googleCaptcha}
                                    sitekey={APP_GOOGLE_RECAPCHA_KEY}
                                    onVerify={() => setCaptchaVerified(true)}
                                    onExpire={() => resetCaptcha()}
                                    tabindex={0}
                                    size="normal"
                                />
                            </div>
                        )}
                        <Button
                            onClick={() =>
                                trackEvent({
                                    eventCategory: occasion,
                                    eventAction: 'CTA Click',
                                    eventLabel: 'Click compose now',
                                })
                            }
                            className={classes.generateButton}
                            type="submit"
                            disabled={!checkGenerateEnabled()}
                        >
                            {createPoemMutation.isLoading ? <CircularProgress /> : 'Compose Now'}
                        </Button>
                        {error && <p className={classes.error}>{error}</p>}
                        <Disclaimer isDadJokeGPT={isDadJokeGPT} />
                    </form>
                </div>
                <div className={classes.landingPageBottom}>
                    <DadJokeLandingPageBottomBg mobile={mobile} />
                </div>
            </>
        );
    }

    return (
        <>
            <div className={classes.contentContainer}>
                <h1 className={classes.title}>
                    <img alt="1800flowers.com MomVerse" src={mobile ? MomVerseMobile : MomVerseDesktop} />
                </h1>
                <p className={classes.subtitle}>
                    Create a personalized poem and get unique gift suggestions via our AI-powered guide.
                </p>
                <form onSubmit={(e) => handleFormSubmit(e)}>
                    <CardWithButtons
                        mobile={mobile}
                        handleOptionChange={handleSetPeopleOption}
                        title="Write a Verse For Your:"
                        options={people}
                        placeholder="Or someone else..."
                    />
                    <CardWithButtonsMultiple
                        mobile={mobile}
                        handleOptionChange={handleSetLikesMomVerse}
                        title="Who Likes:"
                        subtitle="(Select Up To Three)"
                        userSelections={likes}
                        placeholder="Or something else..."
                    />
                    {!googleCaptchaDisabled && (
                        <div className={classes.recaptchaContainer}>
                            <Reaptcha
                                ref={googleCaptcha}
                                sitekey={APP_GOOGLE_RECAPCHA_KEY}
                                onVerify={() => setCaptchaVerified(true)}
                                onExpire={() => resetCaptcha()}
                                tabindex={0}
                                size="normal"
                            />
                        </div>
                    )}
                    <Button
                        onClick={() =>
                            trackEvent({
                                eventCategory: occasion,
                                eventAction: 'CTA Click',
                                eventLabel: 'Click compose now',
                            })
                        }
                        className={classes.generateButton}
                        type="submit"
                        disabled={!checkGenerateEnabled()}
                    >
                        {createPoemMutation.isLoading ? <CircularProgress /> : 'Get Suggestions'}
                    </Button>
                    {error && <p className={classes.error}>{error}</p>}
                    <Disclaimer />
                </form>
            </div>
        </>
    );
};

PoemLandingPage.defaultProps = {
    mobile: false,
};

PoemLandingPage.propTypes = {
    setRecipient: func.isRequired,
    mobile: bool.isRequired,
    isDadJokeGPT: bool.isRequired,
    trackEvent: func.isRequired,
    handlePoemMutationSuccess: func.isRequired,
    handlePoemMutationError: func.isRequired,
    options: object.isRequired,
    selections: object.isRequired,
    setSelections: func.isRequired,
    error: string.isRequired,
    setError: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

const enhance = compose(connect(null, mapDispatchToProps));

export default enhance(PoemLandingPage);
